// $(window).bind("load", function () {
//   alert("start");
//      $('.money').each(function(i, obj) {
//     var remove;
//     remove = $(this).text();
//      remove.replace('PHP','');
//      $(this).text(remove); 
// });
// });
$(window).bind("load", function () {
  
var remove;
$('.money').each(function(i, obj) {
     //     remove = $(this).text();
     // remove = remove.replace("PHP","");
     // $(this).html(remove);
  
  $(this).after( "<span class=\"custom-money\">₱"+ $(this).text() +"</span>" );
});

});
$( document ).ready(function() {
  $( "select.currency-switcher" ).change(function() {
  // alert( "Handler for .change() called." );
    alert($( "select.currency-switcher option:selected" ).text());
});
});
